import { render, staticRenderFns } from "./TenancyAccountingOrders.vue?vue&type=template&id=521c1010&scoped=true&"
import script from "./TenancyAccountingOrders.vue?vue&type=script&lang=js&"
export * from "./TenancyAccountingOrders.vue?vue&type=script&lang=js&"
import style0 from "./TenancyAccountingOrders.vue?vue&type=style&index=0&id=521c1010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521c1010",
  null
  
)

export default component.exports